import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_CONFIG, DYNAMIC_STEPS_CONFIG } from '../../config/dataConfig/FJHeadshotGeneratorData';
import FJConstant from '../../constants/FJConstant';

export const FJSliceHeadshotGenerator = createSlice({
    name: 'headshotGenerator',
    initialState: {
        // tab
        tabIndex: 0,
        // 状态
        currentHeadshotStatus: FJConstant.DEFAULT,
        imageUploadStatus: FJConstant.DEFAULT,
        // 动态步骤相关状态
        currentStepIndex: 0,
        maxSteps: DYNAMIC_STEPS_CONFIG[DEFAULT_CONFIG.category].length - 1,
        // 用户输入
        selectedCategory: DEFAULT_CONFIG.category,
        selectedCategoryKey: DEFAULT_CONFIG.categoryKey,
        selectedGender: DEFAULT_CONFIG.gender,
        selectedProfession: DEFAULT_CONFIG.profession,
        selectedHairPreferences: DEFAULT_CONFIG.hairPreferences,
        selectedClothingPreference: DEFAULT_CONFIG.clothingPreference,
        selectedBackgroundPreference: DEFAULT_CONFIG.backgroundPreference,
        selectedTheme: DEFAULT_CONFIG.theme,
        selectedRatio: DEFAULT_CONFIG.ratio,
        selectedShot: DEFAULT_CONFIG.shot,
        imageInfo: {},
        originImage: null,
        currentCollection: null,
        hairColorNewOption: null,
        selectedAge: null,
        // credit相关
        unitPrice: 10,
        totalOutput: DEFAULT_CONFIG.totalOutput || 0,

        // 生成相关
        generatingHeadshotNum: 0,
        isShowGeneratingHeadshotNum: false,
        headshotPromptDataSet: {},
        currentTaskId: null,
    },
    reducers: {
        setCurrentHeadshotStatus: (state, action) => {
            state.currentHeadshotStatus = action.payload;
        },
        resetHeadshotGeneratorState: state => {
            Object.assign(state, {
                currentHeadshotStatus: FJConstant.DEFAULT,
                imageUploadStatus: FJConstant.DEFAULT,
                currentStepIndex: 0,
                selectedCategory: DEFAULT_CONFIG.category,
                selectedCategoryKey: DEFAULT_CONFIG.categoryKey,
                selectedGender: DEFAULT_CONFIG.gender,
                selectedProfession: DEFAULT_CONFIG.profession,
                selectedHairPreferences: DEFAULT_CONFIG.hairPreferences,
                selectedClothingPreference: DEFAULT_CONFIG.clothingPreference,
                selectedBackgroundPreference: DEFAULT_CONFIG.backgroundPreference,
                selectedTheme: DEFAULT_CONFIG.theme,
                selectedRatio: DEFAULT_CONFIG.ratio,
                selectedShot: DEFAULT_CONFIG.shot,
                imageInfo: {},
                originImage: null,
                currentCollection: null,
                hairColorNewOption: null,
            });
        },
        setImageUploadStatus: (state, action) => {
            state.imageUploadStatus = action.payload;
        },
        setCurrentStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
        },
        setMaxSteps: (state, action) => {
            state.maxSteps = action.payload;
        },
        // 动态步骤相关的 reducers
        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
            // 重置步骤索引
            state.currentStepIndex = 0;
        },
        setSelectedCategoryKey: (state, action) => {
            state.selectedCategoryKey = action.payload;
        },
        setSelectedGender: (state, action) => {
            state.selectedGender = action.payload;
        },
        setSelectedProfession: (state, action) => {
            state.selectedProfession = action.payload;
        },
        setSelectedHairPreferences: (state, action) => {
            state.selectedHairPreferences = action.payload;
        },
        setSelectedClothingPreference: (state, action) => {
            state.selectedClothingPreference = action.payload;
        },
        setSelectedBackgroundPreference: (state, action) => {
            state.selectedBackgroundPreference = action.payload;
        },
        setSelectedTheme: (state, action) => {
            state.selectedTheme = action.payload;
        },
        setSelectedRatio: (state, action) => {
            state.selectedRatio = action.payload;
        },
        setSelectedShot: (state, action) => {
            state.selectedShot = action.payload;
        },
        setImageInfo: (state, action) => {
            state.imageInfo = action.payload;
        },
        setTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setCurrentCollection: (state, action) => {
            state.currentCollection = action.payload;
        },
        setTotalOutput: (state, action) => {
            state.totalOutput = action.payload;
        },
        setGeneratingHeadshotNum: (state, action) => {
            state.generatingHeadshotNum = action.payload;
        },
        setIsShowGeneratingHeadshotNum: (state, action) => {
            state.isShowGeneratingHeadshotNum = action.payload;
        },
        setHeadshotPromptDataSet: (state, action) => {
            state.headshotPromptDataSet = action.payload;
        },
        setCurrentTaskId: (state, action) => {
            state.currentTaskId = action.payload;
        },
        setHairColorNewOption: (state, action) => {
            state.hairColorNewOption = action.payload;
        },
        setOriginImage: (state, action) => {
            state.originImage = action.payload;
        },
        setSelectedAge: (state, action) => {
            state.selectedAge = action.payload;
        },
    },
});

export const {
    setAvatarInfo,
    setAvatarStatus,
    setAvatarResult,
    resetHeadshotGeneratorState,
    setCurrentStepIndex,
    setMaxSteps,
    setSelectedCategory,
    setSelectedCategoryKey,
    setSelectedGender,
    setSelectedProfession,
    setSelectedHairPreferences,
    setSelectedClothingPreference,
    setSelectedBackgroundPreference,
    setSelectedTheme,
    setSelectedRatio,
    setSelectedShot,
    setImageInfo,
    setTabIndex,
    setCurrentCollection,
    setImageUploadStatus,
    setCurrentHeadshotStatus,
    setTotalOutput,
    setGeneratingHeadshotNum,
    setIsShowGeneratingHeadshotNum,
    setHeadshotPromptDataSet,
    setCurrentTaskId,
    setHairColorNewOption,
    setOriginImage,
    setSelectedAge,
} = FJSliceHeadshotGenerator.actions;

export default FJSliceHeadshotGenerator.reducer;
